import { forEach } from 'es-toolkit/compat';
const baseSettingTransforms = {
    'abtest.ids': String,
};
function parseConfig(commands, response) {
    const commandArray = commands.split(',');
    const body = {};
    if (commandArray.length === 1) {
        body[commandArray[0]] = response?.[0];
    }
    else if (commandArray.length > 1) {
        response?.forEach((item) => {
            if (item.key) {
                body[item.key] = item.children?.[0];
            }
        });
    }
    return body;
}
function parseJson(value) {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return value;
    }
}
function parseWithTransformer(transformer, value) {
    try {
        return transformer(value);
    }
    catch (e) {
        return value;
    }
}
function parseConfigValue(value) {
    switch (value) {
        case 'true':
        case 'True':
        case 'TRUE':
            return true;
        case 'false':
        case 'False':
        case 'FALSE':
            return false;
        case '':
            return undefined;
        default:
            return parseJson(value);
    }
}
function transformAutoUpdate(customTransforms, data, experimentOverrides) {
    return data?.options
        ?.split('|')
        .reduce((settings, option) => {
        let pair = option.split('=');
        if (pair.length > 2) {
            pair = [pair[0], pair.slice(1).join('=')];
        }
        const [key, originalValue] = pair;
        const { settingTransforms = {} } = customTransforms;
        Object.assign(settingTransforms, baseSettingTransforms);
        const value = experimentOverrides[key.toLowerCase()] || originalValue;
        const transformer = settingTransforms?.[key];
        const transformedValue = transformer
            ? parseWithTransformer(transformer, value)
            : parseConfigValue(value);
        if (transformedValue !== undefined) {
            settings[key] = transformedValue;
        }
        return settings;
    }, {});
}
function transformAds(data) {
    const adConfig = data.config ? parseJson(data.config) : {};
    const targeting = data.targeting
        ?.split(',')
        .reduce((acc, target) => {
        const [key, value] = target.split('=');
        acc[key] = value;
        return acc;
    }, {});
    return {
        ...adConfig,
        targeting,
        targetingIdl: data.targetingIDL,
    };
}
function transformConfig(customTransforms, data) {
    const transformedTerms = {};
    try {
        if (data.config) {
            const terms = JSON.parse(data.config);
            forEach(terms, (value, key) => {
                const transformer = customTransforms.termsTransforms?.[key];
                transformedTerms[key] = transformer
                    ? parseWithTransformer(transformer, value)
                    : parseConfigValue(value);
            });
        }
    }
    catch (e) {
    }
    return transformedTerms;
}
function getWindowParams() {
    try {
        const searchParams = new URLSearchParams(location.search);
        const lowerCasedKeyParams = Array.from(searchParams).map(([k, v]) => [
            k.toLowerCase(),
            v,
        ]);
        return Object.fromEntries(lowerCasedKeyParams);
    }
    catch (e) {
        return {};
    }
}
export const mapConfigResponse = (options) => {
    return (configResponse) => {
        const { commands, customTransforms = {}, experimentOverrides = getWindowParams(), } = options;
        const response = {};
        if (!(commands && configResponse)) {
            return response;
        }
        const parsedData = parseConfig(commands, configResponse);
        forEach(parsedData, (obj, key) => {
            switch (key) {
                case 'ads': {
                    response[key] = transformAds(obj);
                    break;
                }
                case 'unlock':
                case 'terms': {
                    response[key] = transformConfig(customTransforms, obj);
                    break;
                }
                case 'autoupdate': {
                    response[key] = transformAutoUpdate(customTransforms, obj, experimentOverrides);
                    break;
                }
                default: {
                    response[key] = obj;
                    break;
                }
            }
        });
        return response;
    };
};
